import { render, staticRenderFns } from "./SupplierPersonal.vue?vue&type=template&id=0f7bb0c0&scoped=true&"
import script from "./SupplierPersonal.vue?vue&type=script&lang=js&"
export * from "./SupplierPersonal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPersonal.vue?vue&type=style&index=0&id=0f7bb0c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7bb0c0",
  null
  
)

export default component.exports